//
//
//
//
//
//

export default {
  /* TODO: Change to 'rb-stories-faq' and align CMS as well */
  name: 'rb-pdp-stella-faq',
}
